"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiTheme = void 0;
var breakpoints_1 = require("./breakpoints");
var components_1 = require("./components");
var palette_1 = require("./palette");
var typography_1 = require("./typography");
exports.muiTheme = {
    breakpoints: breakpoints_1.breakpointOptions,
    palette: palette_1.paletteOptions,
    components: components_1.componentTheme,
    typography: typography_1.typographyOptions,
};
//# sourceMappingURL=muiTheme.js.map